import React from "react";
import NewrowPDF from "./RowPDF";
import {
  totalPriceObraEstimativa,
  totalPrice,
  totalPriceComercial,
  totalPriceAlt,
  totalPriceComercialAlt
} from "../../TableCalculations";

const stlye = {
  display: "none"
};

const today = new Date();

const tablePDF = props => (
  <div style={stlye}>
    <table id="toPrint">
      <colgroup>
        <col width="4%" />
        <col width="25%" />
        <col width="7%" />
        <col width="12%" />
        <col width="12%" />
        <col width="12%" />
        <col width="12%" />
        <col width="12%" />
      </colgroup>
      <thead>
        <tr >
          <td colspan="8">
          {props.templateSelected}
          </td>
        </tr>
        <tr>
          <th>Unit</th>
          <th>Material</th>
          <th>Cant./m2</th>
          <th>Cant./Total</th>
          <th>Precio(ud)</th>
          <th>Precio(Total)</th>
          <th>Cant. Comercial</th>
          <th>Precio/(C.Com)</th>
        </tr>
      </thead>
      <tbody>
        <NewrowPDF
          products={props.products}
          waste={props.waste}
          m2={props.m2}
        />
        <tr>
          <td>M2</td>
          <td>Mano de Obra Estimativa</td>
          <td>-</td>
          <td>{props.qtyObraEstimativa}</td>
          <td>{props.obraEstimativa}</td>
          <td>
            ${" "}
            {totalPriceObraEstimativa(
              props.obraEstimativa,
              props.qtyObraEstimativa
            ).toFixed(2)}
          </td>
          <td>-</td>
          <td>
            ${" "}
            {totalPriceObraEstimativa(
              props.obraEstimativa,
              props.qtyObraEstimativa
            ).toFixed(2)}
          </td>
        </tr>
        <tr>
          <td />
          <td />
          <td />
          <td />
          <td>
            <strong>Total Pesos</strong>
          </td>
          <td>
            <span>
              <strong>$</strong>
            </span>{" "}
            {totalPrice(
              props.products,
              props.waste,
              props.m2,
              props.obraEstimativa,
              props.qtyObraEstimativa
            )}{" "}
            <span>
              <strong>+I.V.A</strong>
            </span>
          </td>
          <td />
          <td>
            <span>
              <strong>$</strong>
            </span>{" "}
            {totalPriceComercial(
              props.products,
              props.waste,
              props.m2,
              props.obraEstimativa,
              props.qtyObraEstimativa
            )}{" "}
            <span>
              <strong>+I.V.A</strong>
            </span>
          </td>
        </tr>
        <tr>
          <td />
          <td />
          <td />
          <td />
          <td>
            <strong>Total Pesos / m2</strong>
          </td>
          <td>
            <span>
              <strong>$</strong>
            </span>{" "}
            {(
              totalPrice(
                props.products,
                props.waste,
                props.m2,
                props.obraEstimativa,
                props.qtyObraEstimativa
              ) / props.m2
            ).toFixed(2)}{" "}
            <span>
              <strong>+I.V.A</strong>
            </span>
          </td>
          <td />
          <td>
            {" "}
            <span>
              <strong>$</strong>
            </span>{" "}
            {(
              totalPriceComercial(
                props.products,
                props.waste,
                props.m2,
                props.obraEstimativa,
                props.qtyObraEstimativa
              ) / props.m2
            ).toFixed(2)}{" "}
            <span>
              <strong>+I.V.A</strong>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <table id="toPrint2">
      <colgroup>
        <col width="4%" />
        <col width="25%" />
        <col width="7%" />
        <col width="12%" />
        <col width="12%" />
        <col width="12%" />
        <col width="12%" />
        <col width="12%" />
      </colgroup>
      <thead>
      <tr >
          <td colspan="8">
          {props.alternativeDescription}
          </td>
        </tr>
        <tr>
          <th>Unit</th>
          <th>Material</th>
          <th>Cant./m2</th>
          <th>Cant./Total</th>
          <th>Precio(ud)</th>
          <th>Precio(Total)</th>
          <th>Cant. Comercial</th>
          <th>Precio/(C.Com)</th>
        </tr>
      </thead>
      <tbody>
        <NewrowPDF
          products={props.alternativeProducts}
          waste={props.waste}
          m2={props.m2}
        />
        <tr>
          <td />
          <td />
          <td />
          <td />
          <td>
            <strong>Total Pesos</strong>
          </td>
          <td>
            <span>
              <strong>$</strong>
            </span>{" "}
            {totalPriceAlt(
              props.products,
              props.alternativeProducts,
              props.waste,
              props.m2,
              props.obraEstimativa,
              props.qtyObraEstimativa
            )}{" "}
            <span>
              <strong>+I.V.A</strong>
            </span>
          </td>
          <td />
          <td>
            <span>
              <strong>$</strong>
            </span>{" "}
            {totalPriceComercialAlt(
              props.products,
              props.alternativeProducts,
              props.waste,
              props.m2,
              props.obraEstimativa,
              props.qtyObraEstimativa
            )}{" "}
            <span>
              <strong>+I.V.A</strong>
            </span>
          </td>
        </tr>
        <tr>
          <td />
          <td />
          <td />
          <td />
          <td>
            <strong>Total Pesos / m2</strong>
          </td>
          <td>
            <span>
              <strong>$</strong>
            </span>{" "}
            {(
              totalPriceAlt(
                props.products,
                props.alternativeProducts,
                props.waste,
                props.m2,
                props.obraEstimativa,
                props.qtyObraEstimativa
              ) / props.m2
            ).toFixed(2)}{" "}
            <span>
              <strong>+I.V.A</strong>
            </span>
          </td>
          <td />
          <td>
            {" "}
            <span>
              <strong>$</strong>
            </span>{" "}
            {(
              totalPriceComercialAlt(
                props.products,
                props.alternativeProducts,
                props.waste,
                props.m2,
                props.obraEstimativa,
                props.qtyObraEstimativa
              ) / props.m2
            ).toFixed(2)}{" "}
            <span>
              <strong>+I.V.A</strong>
            </span>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="3">Email: {props.email}</td>
          <td colspan="2">m2 Solicitados: {props.m2}</td>
          <td colspan="3">
            Fecha:{" "}
            {today.getDate() +
              "/" +
              (today.getMonth() + 1) +
              "/" +
              today.getFullYear()}{" "}
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
);

export default tablePDF;
